import './story-contact.scss';
import StoryContact from './StoryContact';

export default StoryContact;
